"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFiles = exports.isFileValid = exports.readFileSegmentAsArrayBufferAsync = void 0;
function readFileSegmentAsArrayBufferAsync(file, start, end) {
    return new Promise(function (resolve, reject) {
        var blob = file.slice(start, end);
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onabort = reject;
        reader.onload = function (e) {
            reader = null;
            blob = null;
            resolve(e.target.result);
        };
        reader.readAsArrayBuffer(blob);
    });
}
exports.readFileSegmentAsArrayBufferAsync = readFileSegmentAsArrayBufferAsync;
function isFileValid(file, mimeType, fileWhiteList) {
    var extension = file.name.split(".").pop();
    var unknownFileType = fileWhiteList.ext.find(function (o) { return o.toUpperCase() == "UNKNOWN"; });
    var unknownFileTypeAccepted = !!unknownFileType;
    var isValid = unknownFileTypeAccepted
        ? true
        : fileWhiteList.ext.findIndex(function (o) { return o.toUpperCase() === extension.toUpperCase(); }) > -1 &&
            (!mimeType ||
                fileWhiteList.mimeType.findIndex(function (o) { return o.toUpperCase() === mimeType.toUpperCase(); }) > -1);
    // if (!isValid)
    //   console.error(
    //     `rejecting file: ${file.name}, ext: ${extension}, mimeType: ${mimeType}`,
    //   );
    return isValid;
}
exports.isFileValid = isFileValid;
function getFile(fileEntry) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            return fileEntry.file(resolve, reject);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function dataReader(entry) {
    return new Promise(function (resolve) {
        var dirReader = entry.createReader();
        var result = new Array();
        dirReader.readEntries(function (entries) {
            return __awaiter(this, void 0, void 0, function () {
                var i, c, file, _a, dr;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            i = 0, c = entries.length;
                            _b.label = 1;
                        case 1:
                            if (!(i < c)) return [3 /*break*/, 9];
                            if (!entries[i].isFile) return [3 /*break*/, 6];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, getFile(entries[i])];
                        case 3:
                            file = _b.sent();
                            result.push(file);
                            return [3 /*break*/, 5];
                        case 4:
                            _a = _b.sent();
                            return [3 /*break*/, 5];
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            if (!entries[i].isDirectory) return [3 /*break*/, 8];
                            return [4 /*yield*/, dataReader(entries[i])];
                        case 7:
                            dr = _b.sent();
                            result.push.apply(result, dr);
                            _b.label = 8;
                        case 8:
                            i++;
                            return [3 /*break*/, 1];
                        case 9:
                            resolve(result);
                            return [2 /*return*/];
                    }
                });
            });
        });
    });
}
function extractFiles(event) {
    return __awaiter(this, void 0, void 0, function () {
        var result, dropArray, i, c, entry, _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    result = new (Array.bind.apply(Array, __spreadArray([void 0], event.dataTransfer.files, false)))().filter(function (f) {
                        return f.type != "" ||
                            ["OBJ", "STL"].includes(f.name.split(".").pop().toUpperCase());
                    });
                    dropArray = new (Array.bind.apply(Array, __spreadArray([void 0], event.dataTransfer.items, false)))();
                    i = 0, c = dropArray.length;
                    _d.label = 1;
                case 1:
                    if (!(i < c)) return [3 /*break*/, 4];
                    entry = dropArray[i].webkitGetAsEntry && dropArray[i].webkitGetAsEntry();
                    if (!(entry && entry.isDirectory)) return [3 /*break*/, 3];
                    _b = (_a = result.push).apply;
                    _c = [result];
                    return [4 /*yield*/, dataReader(entry)];
                case 2:
                    _b.apply(_a, _c.concat([(_d.sent())]));
                    _d.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, result];
            }
        });
    });
}
exports.extractFiles = extractFiles;
//# sourceMappingURL=fileHelpers.js.map